import {useTranslation} from "react-i18next";
import OrderByHeaders from "components/ordering/OrderByHeaders";

// -
import translations from "./translations";
import useCustomTranslation from "core/customTranslation";
import MQ2Table from "./modes/table/MQ2Table";
import MT2GTable from "./modes/table/QT2GTable";

const TableServers = ({
    items,
    itemsShow,
    buttonsTB,
    setButtonsTB,
    checkAll,
    setCheckAll,
    orderingRef,
}) => {
    const {t: _Tt} = useTranslation("tags");
    const {t: _Tc} = useCustomTranslation(translations);

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 899,
    };

    const getTRByModel = (item) => {
        switch (item.model) {
            case "MQ2-4G":
                return <MQ2Table item={item} onClickCheck={onClick} items={items} />;
            case "QT-2G":
                return <MT2GTable item={item} onClickCheck={onclick} items={items} />;
            default:
                return <></>;
        }
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        style={{
                            width: "0.4%",
                            verticalAlign: "bottom",
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                    <th
                        style={{...stickyHeaderStyle}}
                        className="text-center sticky-top border-bottom-sticky">
                        {_Tc("preference_sim")}
                    </th>
                    <th
                        style={{...stickyHeaderStyle}}
                        className="text-center sticky-top border-bottom-sticky">
                        {_Tc("band")}
                    </th>
                    <th
                        style={{...stickyHeaderStyle}}
                        className="text-center sticky-top border-bottom-sticky">
                        PIN
                    </th>
                    <th
                        style={{...stickyHeaderStyle}}
                        className="text-center sticky-top border-bottom-sticky">
                        APN-{_Tt("common.name")}
                    </th>
                    <th
                        style={{...stickyHeaderStyle}}
                        className="text-center sticky-top border-bottom-sticky">
                        APN-{_Tt("common.user")}
                    </th>
                    <th
                        style={{...stickyHeaderStyle}}
                        className="text-center sticky-top border-bottom-sticky">
                        APN-{_Tt("common.password")}
                    </th>
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onChange={onClick}>
                        {getTRByModel(item)}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableServers;
